<template>
    <header class="menu__wrapper">
      <div class="menu__bar">
        <a href="/" title="Home" aria-label="Transparencia">
          <img src="@/assets/logo.png" alt="Santa Tecla Logo" class="logo-header">
        </a>
      </div>
    </header>
  </template>
  
    <style scoped>
    .logo-header {
      height: 5rem;
      cursor: pointer;
        display: flex;
        align-items: center;
    }
  
    .menu__wrapper {
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: 100%;
        padding: 0px 1rem;
        align-items: center;
    }
    </style>